import { medicalReceiptFormatDateByDash, medicalReceiptFormatDateByDot } from '../lib/format';

export const HOSPITAL_DATE_FORMAT_MAPPING = {
  13: medicalReceiptFormatDateByDash, // 계명대학교 동산의료원 - YYYY-MM-DD
  15: medicalReceiptFormatDateByDot, // 한림대학교 춘천성심병원 - YYYY.MM.DD
  16: medicalReceiptFormatDateByDot, // 한림대학교 평촌성심병원 - YYYY.MM.DD
  21: medicalReceiptFormatDateByDot, // 한림대학교 동탄성심병원 - YYYY.MM.DD
};

export const getHospitalDateFormatByHspId = (hspId) => {
  return HOSPITAL_DATE_FORMAT_MAPPING[hspId] || medicalReceiptFormatDateByDash;
};
